// Version : 0.0.1
// Author : VIGNESH

const goldLoanCollectionActionTypes = {
	/*********************** GOLD LOAN REPAYMENT COLLECTION **************************/
	GET_GOLD_LOAN_COLLECTION_LIST_START: 'get_gold_loan_collection_start',
	GET_GOLD_LOAN_COLLECTION_LIST_SUCCESS: 'get_gold_loan_collection_success',
	GET_GOLD_LOAN_COLLECTION_LIST_FAILURE: 'get_gold_loan_collection_failure',
	GET_GOLD_LOAN_COLLECTION_LIST_RESPONSE_RESET: 'get_gold_loan_collection_response_reset',
	GET_GOLD_LOAN_COLLECTION_LIST_RESPONSE_CHANGED: 'get_gold_loan_collection_response_changed',
	/*********************** GOLD LOAN REPAYMENT COLLECTION END  **************************/
};
export default goldLoanCollectionActionTypes;
